import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from '~/Product/Action';
import { showAllProductsAction } from '~/Product/actions';
import { State, ThunkDispatch } from '~/Store';
import Checkbox from '~/UI/Checkbox/Checkbox';
import Icon from '~/UI/Icon';
import { TailwindTooltip } from '~/libs/ui/atoms/TailwindTooltip';

import styles from './styles.less';

export const ShowAllSwitch: React.FunctionComponent<
	React.PropsWithChildren<{
		alternativeProductsCount: number;
		label: React.ReactNode;
		tooltip: React.ReactNode;
	}>
> = ({ alternativeProductsCount, label, tooltip }) => {
	const showAllProducts = useSelector<State, boolean>((state) => state.products.showAllProducts);
	const dispatch: ThunkDispatch<Action> = useDispatch();
	const update = React.useCallback((showAllProducts: boolean) => {
		dispatch(showAllProductsAction(!showAllProducts));
	}, []);

	if (alternativeProductsCount === 0) {
		return null;
	}

	return (
		<div className={styles.container}>
			<Checkbox checked={!showAllProducts} onChange={update}>
				{label}
			</Checkbox>
			<TailwindTooltip
				reference={<Icon name='violet-question-mark' />}
				displayClass='inline-block ml-2'
				position='left'
				portal
			>
				{tooltip}
			</TailwindTooltip>
		</div>
	);
};

ShowAllSwitch.displayName = 'Product.ShowAllSwitch';
